import { render, staticRenderFns } from "./AddhealthArticle.vue?vue&type=template&id=b35228d8&scoped=true"
import script from "./AddhealthArticle.vue?vue&type=script&lang=js"
export * from "./AddhealthArticle.vue?vue&type=script&lang=js"
import style0 from "./AddhealthArticle.vue?vue&type=style&index=0&id=b35228d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35228d8",
  null
  
)

export default component.exports